import React from 'react'
import ErrorBoundary from "../../../error-boundary";

type Props = {
    className?  : string
    style?      : style
    children?   : any
}

export default function FormFlex(props:Props) {
    return (
        <div className={Classes("ui5-form-flex", props.className)} style={props.style}>
            <ErrorBoundary>
                {props.children}
            </ErrorBoundary>
        </div>
    )
}